import { useMutation } from "@tanstack/react-query";
import {
	type CreateIdentificationDocumentRequestDTO,
	postClientIdentificationDocumentsV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useCreateIdentificationDocumentMutation = () =>
	useMutation({
		mutationFn: processResponse(
			(data: CreateIdentificationDocumentRequestDTO) =>
				postClientIdentificationDocumentsV2(data),
		),
	});
